/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import * as graphql from 'generated/graphql';
import { orderBy } from 'lodash';
import { useState } from 'react';

import { useTranslation } from 'react-i18next';
import SidebarSectionHeader from './SectionHeader';
import { Paragraph, Sidebar, Skeleton } from '@treams/treams-ui';
import { Box } from 'reflexbox';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import useViewer from 'packages/kakapo-ui-application/hooks/useViewer';
import moment from 'moment';

type ConversationSideBarItemProps = {
	conversation: graphql.EvaluationSubmission;
	userID: string;
};

const ConversationSideBarItem = ({ conversation, userID }: ConversationSideBarItemProps) => {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const viewer = useViewer();

	const date = moment(conversation.deadline).format('DD/MM/YYYY');
	const time = moment(conversation.deadline).format('HH:mm');

	const conversationsPath =
		viewer?.id === userID ? `/conversations` : `/users/${userID}/conversations`;

	return (
		<Sidebar.Item
			key={conversation.id}
			title={localize(conversation.evaluationForm.title).text}
			subtitle={t('conversation.sidebar.item.dueDateWithTime', { date, time })}
			path={`${conversationsPath}/${conversation.id}`}
			small
		/>
	);
};

export default function SidebarConversationSection(props: {
	userID: string;
	conversationID: string;
}) {
	const { t } = useTranslation();

	const { data } = graphql.useEvaluationSubmissionsQuery({
		variables: { userID: props.userID, last: 100, isArchived: false },
	});

	const [showAll, setShowAll] = useState(false);
	const [isOpen, setIsOpen] = useState(true);
	const conversations = orderBy(
		data?.user.evaluationSubmissions.edges ?? [],
		({ node }) => node.createdAt,
		'desc',
	)
		.map(({ node }) => node)
		.slice(0, showAll ? data?.user.evaluationSubmissions.edges.length : 4);

	return (
		<>
			<SidebarSectionHeader isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
				{t('conversation.sidebar.previous.title')}
			</SidebarSectionHeader>
			{isOpen && (
				<Box mb={3}>
					{!conversations && (
						<Skeleton.Repeat count={3}>
							<Sidebar.Item.Skeleton />
						</Skeleton.Repeat>
					)}
					{conversations?.map((conversation) => (
						<ConversationSideBarItem
							key={conversation.id}
							userID={props.userID}
							conversation={conversation as graphql.EvaluationSubmission}
						/>
					))}
					{!showAll && (
						<Box mx="10px" my={2}>
							<Paragraph>
								<div onClick={() => setShowAll(true)}>
									{t('conversation.sidebar.previous.showAll.title')}
								</div>
							</Paragraph>
						</Box>
					)}
				</Box>
			)}
		</>
	);
}
